import "../Styles/SharedGenericStyles.css"
import { useState, useEffect } from "react";
import { parseAsFloat } from "../Utils/InputUtils";
import { pleaseEnterNumber } from "../Utils/ErrorMessages";

export const IntegerInput = ({
  value = 0,
  name,
  handleChange,
  disabled = false,
}) => {
  const [integerValue, setIntegerValue] = useState(null);

  useEffect(() => {
    const customEvent = {
      target: {
        name: name,
        value: integerValue,
      },
    };
    handleChange(customEvent);
  }, [integerValue]);

  const handleInputChange = (e) => {
    try {
      if (e.target.value === "") {
        e.target.value = 0;
      }
      const parsedValue = parseInt(e.target.value);
      setIntegerValue(parsedValue);
    } catch (error) {
      console.error(error.message);
      // Until better error handling is sorted
      alert(pleaseEnterNumber());
    }
  };

  return (
    <>
      {!isNaN(value) && (
        <input
          type='number'
          value={value}
          name={name}
          onChange={(e) => handleInputChange(e)}
          disabled={disabled}
        />
      )}
    </>
  );
};

export const IntegerInputWithLabel = ({
  inputLabel,
  value = 0,
  name,
  handleChange,
  disabled = false,
}) => {
  const [integerValue, setIntegerValue] = useState(parseInt(value));

  useEffect(() => {
    const customEvent = {
      target: {
        name: name,
        value: integerValue,
      },
    };
    handleChange(customEvent);
  }, [integerValue]);

  const handleInputChange = (e) => {
    try {
      if (e.target.value === "") {
        e.target.value = 0;
      }
      const parsedValue = parseInt(e.target.value);
      setIntegerValue(parsedValue);
    } catch (error) {
      console.error(error.message);
      // Until better error handling is sorted
      alert(pleaseEnterNumber());
    }
  };

  return (
    <div className='clinic-profile-InLine container-100-justified-content'>
      {!isNaN(value) && (
        <>
          <label>{inputLabel}: </label>
          <div className='container-50-align-left'>
            <input
              type='number'
              value={value}
              name={name}
              onChange={(e) => handleInputChange(e)}
              disabled={disabled}
            />
          </div>
        </>
      )}
    </div>
  );
};
